import { render, staticRenderFns } from "./InventoryTransfer.vue?vue&type=template&id=57c16fd0&scoped=true&"
import script from "./InventoryTransfer.vue?vue&type=script&lang=js&"
export * from "./InventoryTransfer.vue?vue&type=script&lang=js&"
import style0 from "../../assets/paper.css?vue&type=style&index=0&id=57c16fd0&scoped=true&lang=css&"
import style1 from "./InventoryTransfer.vue?vue&type=style&index=1&id=57c16fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c16fd0",
  null
  
)

export default component.exports